// Funnel taxonomy as KEYS only — human labels live in the i18n locale files
// (src/locales/*.json) and are resolved with t(`topics.${key}.label`) etc.
// Keys match the API enums. Carefunded's own taxonomy (see ADR 0001).

export const TOPIC_KEYS = [
  "stress_burnout", "mood", "anxiety", "relationships", "self_image",
  "work_study", "life_events", "family", "sleep_habits", "direction", "unsure",
] as const;

export const SUBTOPIC_KEYS: Record<string, string[]> = {
  stress_burnout: ["overload", "burnout", "bore_out", "recovery", "calm_breathing", "boundaries", "other"],
  mood: ["low_energy", "down", "no_joy", "rumination", "motivation", "other"],
  anxiety: ["panic", "social_anxiety", "phobia", "constant_worry", "tension", "other"],
  relationships: ["partner", "breakup", "friends", "loneliness", "work_relations", "other"],
  self_image: ["self_worth", "assertiveness", "perfectionism", "body_image", "other"],
  work_study: ["workload", "career_choice", "exams", "focus", "conflict", "other"],
  life_events: ["loss_grief", "transition", "separation", "illness", "trauma", "other"],
  family: ["parenting", "household_tension", "communication", "blended_family", "other"],
  sleep_habits: ["sleep", "energy", "routine", "screen_balance", "other"],
  direction: ["meaning", "big_choices", "values", "stuck", "other"],
  unsure: ["just_exploring", "other"],
};

export const REGION_KEYS = ["flanders", "brussels", "wallonia", "netherlands", "other"] as const;
export const LANGUAGE_KEYS = ["nl", "fr", "en"] as const;
export const GENDER_KEYS = ["", "f", "m"] as const; // "" → 'none' label

export const eur = (cents: number) => `€${(cents / 100).toFixed(0)}`;
